import axios from "axios";
import store from "@/store";
import { MessageBox, Message } from "element-ui";
//axios.create 创建一个axios实例  我们给这个实例编写配置，后续所有通过实例发送的请求，都受当前配置约束
const $http = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 5000,
  headers: {
    "Content-Type": "application/json;charset=UTF-8"
  }
});

// 添加请求拦截器
$http.interceptors.request.use(
  function(config) {
    // 在发送请求之前做些什么
    // console.log(config)

    config.headers["Authorization"] = store.state.token;
    config.headers["timestamp"] = store.state.headers.timestamp;
    config.headers["nonstr"] = store.state.headers.nonstr;

    return config;
  },
  function(error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
$http.interceptors.response.use(
  function(response) {
    // 对响应数据做点什么
    let res = response;

    if (res.status !== 200) {
      Message({
        message: res.msg || "Error",
        type: "error",
        duration: 5 * 1000
      });

      if (response.data.code === 20105) {
        //如果是token过期，跳转至登录
        // Message.error("登录已过期，请重新登录！");
        store.commit("gettoken", "");
        store.commit("getUserData", "");
        // util.goLogin();
      }
    } else {
      return res.data;
    }

    // return res;
  },
  function(error) {
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);

export default $http;



// WEBPACK FOOTER //
// ./src/utils/request.js